import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import reliableCar from 'shared/assets/images/articles/leasing/reliable-car.png';

import s from './LeasingReliablePartner.css';

class LeasingReliablePartner extends React.Component {
  render() {
    const year = 14;
    const cars = 6450;
    const partners = 100;
    const employees = 60;

    return (
      <div className={s.root}>
        <div className={s.bg} />
        <div className={s.title}>
          <FormattedMessage id={'avtobazar.ua – надежный финансовый партнер'} />
        </div>
        <img className={s.image} src={reliableCar} alt="" />
        <div className={s.info}>
          <div className={s.block}>
            <div className={s.left}>
              <b>{year}</b>
              <div>
                <FormattedMessage id={'Лет на рынке'} />
              </div>
            </div>
            <div className={s.right}>
              <b>{cars}&#8314;</b>
              <div>
                <FormattedMessage id={'Автомобилей на сайте'} />
              </div>
            </div>
          </div>
          <div className={s.block}>
            <div className={s.left}>
              <b>{partners}&#8314;</b>
              <div>
                <FormattedMessage id={'Корпоративных партнеров'} />
              </div>
            </div>
            <div className={s.right}>
              <b>{employees}</b>
              <div>
                <FormattedMessage id={'Сотрудников компании'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(LeasingReliablePartner);



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingReliablePartner/LeasingReliablePartner.js